import apis from '../../api/apis';
import BaseModel from './BaseModel';

export default class Api extends BaseModel {
  static api = apis;
}
